import * as React from 'react';
import './footer.css';

const Footer: React.StatelessComponent<{}> = props => {
  return <footer className="footer-habitat">{props.children}</footer>;
};

export default Footer;
